import { render, staticRenderFns } from "./SupplierGroupCreateView.vue?vue&type=template&id=b303335c"
import script from "./SupplierGroupCreateView.vue?vue&type=script&lang=js"
export * from "./SupplierGroupCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports